// extracted by mini-css-extract-plugin
export default {"item":"Nav_item__yPzaZ","link":"Nav_link__qo3vx"};